import { ApolloProvider, ApolloClient, InMemoryCache } from "@apollo/client";
import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { createUploadLink } from "apollo-upload-client";

import { PropertyListingsSearch } from "@components";
import { Home, TeamMember, PropertyListing, TeamMemberNew } from "@components/Pages";

import { ServerDataContext } from "../../contexts";
import type { ServerData } from "../../contexts";

import { Nav } from "./Nav";
import * as styles from "./Main.styles";

const Main = ({ csrfToken, ...rest }: ServerData) => {
  const headers: Record<string, string> = {};

  if (process.env.NODE_ENV === "development") {
    loadDevMessages();
    loadErrorMessages();
  }

  if (csrfToken) {
    headers["X-CSRF-Token"] = csrfToken;
  }

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: createUploadLink({ uri: "/graphql", headers }),
  });

  return (
    <ServerDataContext.Provider value={{ csrfToken, ...rest }}>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <Nav />
          <div css={styles.content}>
            <Routes>
              <Route element={<ScrollToTop />} />
              <Route path="/" element={<Home />} />
              <Route path="/team_member/new" element={<TeamMemberNew />} />
              <Route path="/team_members/:slug" element={<TeamMember />} />
              <Route path="/mls_listings" element={<PropertyListingsSearch />} />
              <Route path="/property_listings/:slug" element={<PropertyListing />} />
            </Routes>
          </div>
        </BrowserRouter>
      </ApolloProvider>
    </ServerDataContext.Provider>
  );
};

const ScrollToTop = () => {
  window.scrollTo(0, 0);
  return null;
};

export { Main };
